// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FunnelTrendSvg from '@rsuite/icon-font/lib/charts/FunnelTrend';
var FunnelTrend = createSvgIcon({
  as: FunnelTrendSvg,
  ariaLabel: 'funnel trend',
  category: 'charts',
  displayName: 'FunnelTrend'
});
export default FunnelTrend;